import assert from 'assert-ts';
import {KeySelector} from '../types';

export const compare = <T>(key: KeySelector<T>, a: T, b: T): number => {
  const [aVal, bVal] =
    typeof key === 'function' ? [key(a), key(b)] : [a[key], b[key]];

  if (aVal === undefined || aVal === null) {
    if (bVal === undefined || bVal === null) return 0;
    else return -1;
  }

  if (bVal === undefined || bVal === null) return 1;

  const aType = typeof aVal;
  const bType = typeof bVal;

  if (
    !assert.soft(
      aType === bType,
      'orderBy do cannot sort by values of different types',
      {aVal, bVal, aType, bType},
    )
  ) {
    return 0;
  }

  switch (aType) {
    case 'number':
      return ((aVal as unknown) as number) - ((bVal as unknown) as number);
    case 'string':
      return ((aVal as unknown) as string).localeCompare(
        (bVal as unknown) as string,
      );
    default: {
      assert.soft(false, 'query.compare: cannot sort by type', {
        type: aType,
      });
      return 0;
    }
  }
};
